


// system
import { Injectable } from '@angular/core';


//services
//import { MapRendererService } from './map-renderer.service';  // circular
import { BehaviorSubject } from 'rxjs';


//intervaces
//import {  } from "";


@Injectable({
  providedIn: 'root'
})
export class DisplayMessageToUserService {

  private langUA = {
    errors: {
      'noCitiesByCurrentPrefix': 'Населених пунктів не знайдено. Перевірте назву населеного пункту.',
      'validSymbolsForInput': 'Заповнюйте назву населеного пункту лише українською без використання цифр (щонайменше 2 літери). Або індекс, використовуючи лише цифри (5 знаків).',
      'postIndexNotFound': 'Поштовий індекс не знайдено. Перевірте правильність вказаного індексу.',
      'filtersNotApplyToOneOffice': 'Фільтрація не доступна для одного відділення. Перевірте наявність послуг, що вас цікавлять у інформації про відділення.',
      'filtersNotApplyToEmptyOfficesList': 'Список відділень порожній. Для застосування фільтрів вкажіть місто.',
      'wrongPostCode': 'Індекс не знайдено. Перевірте правильність заповнення.'
    },
    messages: {
      'noOfficesInCurrentCity': 'Даний населений пункт обслуговується пересувним ВПЗ, інформація про його графіку роботи буде доступна в цьому розділі сайту найближчим часом', //'Відділення відсутні в данному населеному пінкті.',
      'noOfficesInCurrentCityAfterFilterApply': 'На жаль, за цим запитом нічого не знайдено. \n <span> Спробуйте змінити налаштування фільтра або перевірити правильність введення даних.</span>',
      'selectCityFromDropdown': 'Необхідно обрати населений пункт із переліку.',
      'statusOccupied': 'Тимчасово окуповане',
      'lockerKyivOdesa': 'Поштомати працюють у тестовому режимі в Києві та Одесі'
    },
    tags: {
      shippedOffAtSameDay: "Відправка до 18:00",
      nowOpened: "Зараз відчинені",
      openedAfter19hours: "Працюють після 19:00",
      openedAtDaysOff: "Працюють у вихідні",
      EXPRESS: "Укрпошта Експрес",
      STANDARD: "Укрпошта Стандарт",
      // expressDeliveryDHL: "Експрес-доставка DHL",
      prepayNewspaper: "Оформлення передплати",
      businessPriority: "Пріоритет для бізнесу",
      sevenDayOnWeek: "7 днів на тиждень",
      // happyHurryPaymentTransfer: "«Щасливі години» -50% на комісію з платежів",
      urgentTransrers: "Tермінові перекази",
      hurryPaymentTransfer: "Tермінові грошові перекази",
      paymentTransferInForeignCurrency: "Виплата переказів в іноземній валюті",
      cardPayment: "Оплата карткою",
      cashRecievingFromCard: "Видача готівки з картки",
      communalPayments: "Комунальні та інші платежі",
      preorderOnline: "Прийом відправлень, оформлених он-лайн",
      interationalDelivery: "Доставка за межі України",
      onlineShopping: "Онлайн замовлення та роздрібний продаж",
      shippedFreightAll: "ВСІ",
      shippedFreightMv: "Поштові",
      shippedFreightVv: "Вантажні",
      shippedFreightPm: "Поштомати",
      shippedFreightPudo: "Точки видачі",
      unknown1: "Перекази",
      unknown2: "Виплата післяплати",
      cargoDelivery: "Прийом вантажів"
    }
  };
  private displayMessageOnMapSubject: BehaviorSubject<{ isDisplay: boolean, messageText: string }> = new BehaviorSubject<{ isDisplay: boolean, messageText: string }>(null);
  
  public getDisplayMessageOnMapSubject(): BehaviorSubject<{ isDisplay: boolean, messageText: string }> {
    return this.displayMessageOnMapSubject;
  }

  constructor(
    //private map: MapRendererService  // circular
  ) {
    //Object.frezze(  )
  }



  // in future mb cut to separate service
  public getLang(langISO: string) {
    switch (langISO) {
      case 'UA':
        return Object.assign({}, this.langUA);
        break;
      default:
        return Object.assign({}, this.langUA);
        break;
    }
  }

  public getCurrentLang() {
    return this.getLang('UA')
  }

  public displayMessageOnMap(isDisplay: boolean, messageText: string = '') {
    if (isDisplay === true || isDisplay === false) {
      this.displayMessageOnMapSubject.next({ isDisplay: isDisplay, messageText: messageText })
    }
  }
  


}
